import React from 'react';
import LegalDocument from './LegalDocument';
import { websiteTermsOfUse } from '../content/legalTexts';
import LegalCompanyDetails from './LegalCompanyDetails';

function TermsOfUse() {
  return (
    <section className="faq terms-nd-condition web-site">
      <div className="container">
        <LegalDocument doc={websiteTermsOfUse} />
        <LegalCompanyDetails />
      </div>
    </section>
  );
}

export default TermsOfUse;
